import { render, staticRenderFns } from "./BetBets.vue?vue&type=template&id=5f7e0aec&"
import script from "./BetBets.vue?vue&type=script&lang=js&"
export * from "./BetBets.vue?vue&type=script&lang=js&"
import style0 from "./BetBets.vue?vue&type=style&index=0&id=5f7e0aec&prod&lang=css&"
import style1 from "./BetBets.vue?vue&type=style&index=1&id=5f7e0aec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports